export default __webpack_public_path__ + "static/media/jp.5d4d1d1e.svg";